import { render, staticRenderFns } from "./newsPage03.vue?vue&type=template&id=7f6a625f&scoped=true&"
import script from "./newsPage03.vue?vue&type=script&lang=js&"
export * from "./newsPage03.vue?vue&type=script&lang=js&"
import style0 from "./newsPage03.vue?vue&type=style&index=0&id=7f6a625f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6a625f",
  null
  
)

export default component.exports